import './Tooltip.scss'

import { useRef, useState } from 'react'

const Tooltip = ({ align = 'center', position = 'top', text, children }) => {
    const [tooltipVisible, setTooltipVisible] = useState(false)
    const tooltipVisibilityTimeoutRef = useRef(null)

    const onTouchStart = () => {
        clearTimeout(tooltipVisibilityTimeoutRef.current)
        setTooltipVisible(true)
        tooltipVisibilityTimeoutRef.current = setTimeout(() => setTooltipVisible(false), 2000)
    }

    return (
        <span className="tooltip" onTouchStart={onTouchStart}>
            {children}

            <span className={`tooltip-text ${position} ${align} ${tooltipVisible ? 'visible' : ''}`}>{text}</span>
        </span>
    )
}

export default Tooltip